import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { formValueSelector, change } from 'redux-form';
import cx from 'classnames';
import Accordion from 'react-bootstrap/Accordion';
import withStyles from 'isomorphic-style-loader/withStyles';
import Button from 'react-bootstrap/Button';

import Loader from '../../../Common/Loader/Loader';
import CurrencyConverter from '../../../CurrencyConverter/CurrencyConverter';

import messages from '../../../../locale/messages';
import { createBooking } from '../../../../actions/siteadmin/ManualBooking/createBooking';
import ToolTipContent from '../../../Common/ToolTipContent/ToolTipContent';
import { getPricingDetails } from '../../../../helpers/bookingHelper';
import showToaster from '../../../../helpers/toastrMessgaes/showToaster';
import { getNearestPreferredPartner } from '../../../../actions/siteadmin/ManualBooking/getNearestPreferredPartner';

import AccordionArrow from '../../../../../public/Icons/accordionArrow.svg';
import bt from '../../../../components/commonStyle.css';

class PricingDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: false,
            bookingArrow: false,
        }
        this.toggleSelected = this.toggleSelected.bind(this);
        this.toggleArrowSelected = this.toggleArrowSelected.bind(this);
    }

    toggleSelected() {
        this.setState((prevState) => ({
            selected: !prevState.selected,
        }));
    }

    toggleArrowSelected() {
        this.setState((prevState) => ({
            bookingArrow: !prevState.bookingArrow
        }));
    }

    renderSubCategory = (data) => {
        let hoursLabel, pricingType, price;
        pricingType = data?.categoryData?.pricingType;
        // Admin-chosen hours (>= category minimum); falls back to the minimum.
        const shownHours = Number(data?.hours) > 0 ? Math.max(Number(data.hours), Number(data.pricingDetails?.multiplierValue) || 0) : Number(data.pricingDetails?.multiplierValue);
        hoursLabel = shownHours > 1 ? 'hr(s)' : 'hr';
        price = pricingType == "hourly" ? Number(data.pricingDetails?.convertBasePrice) * shownHours :
            Number(data.pricingDetails?.convertBasePrice) * Number(data.quantity);
        return (
            <div className="commonSubCategoryPricingSubItem">
                <span>
                    {data?.name}&nbsp;{'x'}&nbsp;{pricingType == 'hourly' ? <span>{shownHours}{hoursLabel} </span> : data?.quantity}
                </span>
                <CurrencyConverter amount={price} />
            </div>
        )
    }

    setPaymentType = (type) => {
        this.props.change('ManualBookingForm', 'paymentType', type);
    }

    handleSubmit = async () => {
        const { email, firstName, lastName, phoneCountryCode, phoneDialCode, phoneNumber, preferredPartnerId, isPreferredProvider, scheduleFrom, bookingType } = this.props;
        const { paymentType, cardPaymentMethodId, walletBalance, base, rates, ordersDetails: orders } = this.props;
        if (isPreferredProvider && !preferredPartnerId) {
            return showToaster({ messageId: 'selectPartner', toasterType: 'error' });
        }
        // Payment: 2 = card, 3 = wallet, 4 = send the client a secure link to add/confirm a card (Phase 2).
        const sendLink = paymentType === 4;
        if (!sendLink) {
            if (paymentType !== 2 && paymentType !== 3) {
                return showToaster({ requestContent: 'Choose a payment method (card, wallet, or send the client a link).', toasterType: 'error' });
            }
            if (paymentType === 2 && !cardPaymentMethodId) {
                return showToaster({ requestContent: 'This client has no saved card on file.', toasterType: 'error' });
            }
            if (paymentType === 3) {
                const { total } = getPricingDetails(orders, base, rates);
                if (Number(walletBalance || 0) < Number(total || 0)) {
                    return showToaster({ requestContent: 'Insufficient wallet balance for this booking.', toasterType: 'error' });
                }
            }
        }
        const { createBooking, ordersDetails, categoryId, location, lat, lng, userId, reviewDescription, questionnaire } = this.props;
        await createBooking({
            userId,
            email,
            firstName,
            lastName,
            phoneCountryCode,
            phoneDialCode,
            phoneNumber,
            bookingType,
            scheduleFrom: bookingType === 2 ? moment(scheduleFrom).unix() : null,
            ordersDetails: JSON.stringify(ordersDetails),
            categoryId: Number(categoryId),
            location,
            lat,
            lng,
            preferredPartnerId,
            paymentType,
            paymentMethodId: (!sendLink && paymentType === 2) ? cardPaymentMethodId : null,
            collectFromClient: sendLink,
            reviewDescription: reviewDescription || null,
            questionnaire: questionnaire || null
        })
    }

    getPreferredProvider = () => {
        const { subCategoryId, userId, lat, lng, getNearestPreferredPartner } = this.props;
        getNearestPreferredPartner({ subCategoryId, userId, lat, lng, searchList: '' })
    }

    // Payment-method selector (cash removed). Card = authorization hold on the client's saved card;
    // Wallet = debit the client's balance. The chosen amount is captured/settled at job completion.
    renderPaymentSelector = (total) => {
        const { paymentType, cardLast4, cardBrand, cardPaymentMethodId, walletBalance } = this.props;
        const hasCard = !!cardPaymentMethodId;
        const balance = Number(walletBalance || 0);
        const walletEnough = balance >= Number(total || 0);
        const optBase = { display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: '8px', cursor: 'pointer', marginBottom: '8px', fontSize: '14px' };
        const active = { borderColor: '#e11900', boxShadow: '0 0 0 1px #e11900', background: '#fff5f4' };
        const disabled = { opacity: 0.5, cursor: 'not-allowed' };
        return (
            <div style={{ margin: '14px 0 4px' }}>
                <div style={{ fontWeight: 600, fontSize: '13px', marginBottom: '8px', color: '#111' }}>Payment method</div>
                <div
                    style={Object.assign({}, optBase, hasCard ? {} : disabled, paymentType === 2 ? active : {})}
                    onClick={() => hasCard && this.setPaymentType(2)}
                    role="button"
                    aria-disabled={!hasCard}
                >
                    <input type="radio" readOnly checked={paymentType === 2} disabled={!hasCard} />
                    <span>{hasCard
                        ? `Card ${cardBrand ? cardBrand.charAt(0).toUpperCase() + cardBrand.slice(1) : ''} •••• ${cardLast4}`.trim()
                        : 'Card — no card on file'}</span>
                </div>
                <div
                    style={Object.assign({}, optBase, walletEnough ? {} : disabled, paymentType === 3 ? active : {})}
                    onClick={() => walletEnough && this.setPaymentType(3)}
                    role="button"
                    aria-disabled={!walletEnough}
                >
                    <input type="radio" readOnly checked={paymentType === 3} disabled={!walletEnough} />
                    <span>Wallet — ${balance.toFixed(2)}{!walletEnough ? ' (insufficient)' : ''}</span>
                </div>
                {/* Phase 2: don't charge now — text/email the client a simple link to add a card & confirm.
                    Always available (works whether or not the client already has a card). */}
                <div
                    style={Object.assign({}, optBase, paymentType === 4 ? active : {})}
                    onClick={() => this.setPaymentType(4)}
                    role="button"
                >
                    <input type="radio" readOnly checked={paymentType === 4} />
                    <span>📩 Send client a link to add a card &amp; confirm</span>
                </div>
            </div>
        );
    }

    render() {
        const { formatMessage } = this.props.intl;
        const { ordersDetails, loader, resetForm, bookingLoading, base, rates, isRandomProviderSelection, isPreferredProvider, bookingType } = this.props;
        const { serviceFee, visitFee, total, subTotal } = getPricingDetails(ordersDetails, base, rates);

        let categoryName, showSubmit, submitMessage;

        categoryName = ordersDetails[0]?.categoryData?.name;
        showSubmit = (isRandomProviderSelection || isPreferredProvider || bookingType == 2)
        submitMessage = (isRandomProviderSelection || isPreferredProvider) ? messages?.bookNow : messages?.next;

        return (
            <>
                {loader && <div><Loader type="circle" show={loader} /></div>}
                {!loader && <div>
                    <p className='commonSubCategorySliderHeading'>  {formatMessage(messages.priceSummary)}</p>
                    <div className='commonSubCategoryPricingInfoContainer'>
                        <Accordion defaultActiveKey="0" className='commonSubCategoryPricingAccordion'>
                            <Accordion.Toggle eventKey="0" className='commonSubCategoryPricingAccordionHeading commonSubCategoryPricingItemWrapper' onClick={this.toggleSelected}>
                                <div className='commonSubCategoryPricingItem commonSubCategoryPricingSubHeading'>
                                    {categoryName}
                                    <span className='accordionArrow'>
                                        <img src={AccordionArrow} alt="" className={cx(!this.state.selected ? 'accordionArrowDown' : 'accordionArrowUp')} />
                                    </span>
                                </div>
                                <CurrencyConverter amount={subTotal} />
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="0" className='commonSubCategoryPricingAccordionBody'>
                                <div>
                                    {ordersDetails?.map((item) => { return (this.renderSubCategory(item)) })}
                                </div>
                            </Accordion.Collapse>
                        </Accordion>
                        {visitFee > 0 && <div className='commonSubCategoryPricingItemWrapper commonSubCategoryPricingSubHeading'><div className='commonSubCategoryPricingItem commonSubCategoryPricingItemAlignBase svgImg'><ToolTipContent label={formatMessage(messages.vistFeeContent)} />{formatMessage(messages.travelCharge)}</div><CurrencyConverter amount={visitFee} /></div>}
                        {serviceFee > 0 && <div className='commonSubCategoryPricingItemWrapper commonSubCategoryPricingSubHeading'><div className='commonSubCategoryPricingItem commonSubCategoryPricingItemAlignBase svgImg'><ToolTipContent label={formatMessage(messages.serviceFeeContent)} />{formatMessage(messages.serviceFee)}</div><CurrencyConverter amount={serviceFee} /></div>}
                        <hr className='commonSubCategoryPricingDivider' />
                        <div className='commonSubCategoryPricingItemWrapper commonSubCategoryPricingHeading'><div className='commonSubCategoryPricingItem'>{formatMessage(messages.total)}</div><CurrencyConverter amount={total} /></div>
                        {this.renderPaymentSelector(total)}
                        <div className='commonSubCategoryPricingBtnContainer'>
                            <Button onClick={() => resetForm()} className={cx(bt.btnSecondary)}>{isPreferredProvider ? formatMessage(messages.back) : formatMessage(messages.reset)}</Button>
                            <Loader
                                type={"button"}
                                buttonType={"button"}
                                show={bookingLoading}
                                disabled={bookingLoading}
                                className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                                label={formatMessage(bookingType == 2 ? messages.scheduleNow : submitMessage)}
                                handleClick={() => showSubmit ? this.handleSubmit() : this.getPreferredProvider()}
                            />
                        </div>
                    </div>
                </div>
                }
            </>
        )
    }
}

const selector = formValueSelector('ManualBookingForm');

const mapState = (state) => ({
    userId: selector(state, 'userId'),
    email: selector(state, 'email'),
    firstName: selector(state, 'firstName'),
    lastName: selector(state, 'lastName'),
    phoneCountryCode: selector(state, 'phoneCountryCode'),
    phoneDialCode: selector(state, 'phoneDialCode'),
    phoneNumber: selector(state, 'phoneNumber'),
    categoryId: selector(state, 'categoryId'),
    location: selector(state, 'location'),
    scheduleFrom: selector(state, 'scheduleFrom'),
    // location: selector(state, 'location'),
    lat: selector(state, 'lat'),
    lng: selector(state, 'lng'),
    bookingType: selector(state, 'bookingType'),
    bookingLoading: state?.booking?.bookingLoading,
    isRandomProviderSelection: selector(state, 'isRandomProviderSelection'),
    isPreferredProvider: selector(state, 'isPreferredProvider'),
    preferredPartnerId: selector(state, 'preferredPartnerId'),
    paymentType: selector(state, 'paymentType'),
    cardLast4: selector(state, 'cardLast4'),
    cardBrand: selector(state, 'cardBrand'),
    cardPaymentMethodId: selector(state, 'cardPaymentMethodId'),
    walletBalance: selector(state, 'walletBalance'),
    reviewDescription: selector(state, 'reviewDescription'),
    questionnaire: selector(state, 'questionnaire'),
    base: state?.currency?.base,
    rates: state?.currency?.rates,
});
const mapDispatch = {
    change,
    createBooking,
    getNearestPreferredPartner
}

export default injectIntl(withStyles(bt)(connect(mapState, mapDispatch)(PricingDetails)));